import type { ReactNode } from 'react';
import { useState } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@chakra-ui/react';

import { authInputWithToggleClass } from '../styles';

enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
}

interface PasswordInputProps {
  register: UseFormRegisterReturn;
  placeholder: string;
  'data-testid': string;
  isInvalid?: boolean;
  autoComplete?: string;
}

const stylesheet = {
  wrapper: 'relative w-full',
  toggleButton:
    'absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer bg-transparent text-[12px] font-bold tracking-[0.04em] uppercase text-semantic-text-tertiary hover:text-semantic-emerald',
};

export function PasswordInput({
  register,
  placeholder,
  'data-testid': dataTestId,
  isInvalid = false,
  autoComplete,
}: Readonly<PasswordInputProps>): ReactNode {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleToggle = () => setShow((prev) => !prev);

  return (
    <div className={stylesheet.wrapper}>
      <Input
        {...register}
        type={show ? InputType.TEXT : InputType.PASSWORD}
        placeholder={placeholder}
        className={authInputWithToggleClass}
        data-testid={dataTestId}
        isInvalid={isInvalid}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        onClick={handleToggle}
        className={stylesheet.toggleButton}
      >
        {show ? t('common.hide') : t('common.show')}
      </button>
    </div>
  );
}
